import { createAsyncThunk } from "@reduxjs/toolkit";
import { PROFILE } from "constants/api";
import axios from "utils/http";

export interface IGetProfileResponse extends ApiResponse {
  data: IProfile;
}

export interface IAccountDetailsResponse extends ApiResponse {
  data: IAccountDetails;
}

interface IChangePasswordArgs extends ReduxAction {
  payload: IChangePassword;
}

export const getProfile = createAsyncThunk(
  PROFILE.DETAIL,
  async ({ onFailure }: ReduxAction, { rejectWithValue }) => {
    try {
      const { data }: IGetProfileResponse = await axios.get(PROFILE.DETAIL);
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const getAccountDetails = createAsyncThunk(
  PROFILE.ACCOUNT_DETAILS,
  async ({ onFailure }: ReduxAction, { rejectWithValue }) => {
    try {
      const { data }: IAccountDetailsResponse = await axios.get(
        PROFILE.ACCOUNT_DETAILS
      );
      return data;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);

export const changePassword = createAsyncThunk(
  PROFILE.CHANGE_PASSWORD,
  async (
    { payload, onSuccess, onFailure }: IChangePasswordArgs,
    { rejectWithValue }
  ) => {
    try {
      const { message }: ApiResponse = await axios.post(
        PROFILE.CHANGE_PASSWORD,
        payload
      );
      if (onSuccess) onSuccess(message);
      return message;
    } catch (error) {
      if (onFailure) onFailure(error as IErrorResponse);
      return rejectWithValue({ error });
    }
  }
);
